import React from "react";

const keertivarma = () => {
  return (
    <div>
      <h1>Keertivarma</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        There was no CGPA criteria. Out of the 105 candidates, 67 candidates
        were shortlisted as part of resume shortlisting. Three roles were
        offered - C++, DevEx- Python, QA - Python
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?{" "}
      </p>

      <ol>
        <li>Online Aptitude Round was conducted on the 19th of September. </li>
        <li>
          <strong>Surprise</strong> offline Aptitude Round was conducted on the
          28th of September for 11 students.{" "}
        </li>
        <li>
          Interviews were taken on the same day as the offline Aptitude Round.{" "}
        </li>
        <li>
          Finally, there was a Cultural Fitness Assessment taken on the 3rd of
          October.
        </li>
      </ol>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
      </p>

      <ol>
        <li>
          2 Coding questions on Python, since I had chosen the QA-Python role.{" "}
        </li>
        <li>
          10 questions based on Python and Software Development and Testing
        </li>
      </ol>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        After the aptitude round, an offline Aptitude Round was conducted among
        11 students selected via the online Aptitude Round initially. Then among
        the 11 students, 4 students were shortlisted for interviews. Out of the
        4, 2 were shortlisted for the Cultural Fitness Assessment.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist was released 3 days before the interviews. But, since I
        had considerable time between the online Aptitude and interviews, I
        started preparing immediately after the online Aptitude. During this
        period, I focused on Python - basics, development, testing. I also
        focused on my resume. I focused on OS, DBMS, OOPS concepts, and my
        projects.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were 2 interview rounds namely -
      </p>

      <ol>
        <li>Technical + HR - 4 were shortlisted </li>
        <li>Cultural Fitness Assessment - 2 students were shortlisted</li>
      </ol>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The interviewers focused on Python - syntax, and other libraries of
        Python . They asked me 2 DBMS queries which I was able to answer. Then I
        was asked Software Development and Testing principles. Then they shifted
        their focus on my projects, of which my AI/ML project in Python proved
        to be of great advantage. Finally, there were some HR questions, like
        what are your strengths, what are your hobbies, family background etc.{" "}
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        DSA - Strivers A2Z Sheet
        <br />
        DBMS - Notes by CodeHelp by LoveBabbar
        <br />
        OS - Notes by CodeHelp by LoveBabbar
        <br />
        Python - Codebasics, BroCode videos on YouTube
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />I was asked about my AI/ML project in Python. I was able to
        explain it briefly to them. I was also asked about my work as a
        Coordinator in Impressions 24, and in the DSAI club.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        The company prefers C++ and Python as its primary language for coding.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Focus on DSA, OOPS, and DBMS concepts in particular.
      </p>

      <p>
        <strong>Contact Info</strong>
        <br />
        <strong>Phone No :</strong> 7738893158
        <br />
        <strong>Email :</strong> <a href="mailto:keertivarma.vr@gmail.com">keertivarma.vr@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/keertivarma-v-r-392a16283/"> Keertivarma </a>
      </p>
    </div>
  );
};

export default keertivarma;
